export default "__VITE_ASSET__b8172cd9__"